<template>
  <div class="p-login">
    <div class="p-login__form">
      <img class="p-login__form__logo"
      :alt="$t('functional.signableLogo')"
      src="../assets/signable_cropped.svg" />
      <transition name="fade">
        <v-loading-spinner
          class="p-login-form--loading"
          :login="true"
          v-if="loading" />
      </transition>
      <v-form :onSubmit="validateForm" method="post" data-vv-scope="login">
        <div slot="row">
          <v-input
            type="text"
            :placeholder="$t('login.emailAddress')"
            v-model="email"
            :class="{ 'a-input--error': errors.has('login.email') }"
            v-validate="'required|email'"
            data-vv-name="email"
            :data-vv-as="$t('login.email')"
            data-vv-delay="1000"
            data-vv-scope="login"
            data-test="login-email" />
          <v-message
            type="error"
            subtype="basic"
            v-show="errors.has('login.email')"
            data-test="login-email-error">
            <icon slot="icon" name="times" />
            <span slot="text">{{ errors.first('login.email') }}</span>
          </v-message>
        </div>
        <div slot="row">
          <v-input
            type="password"
            :placeholder="$t('login.password')"
            :class="{ 'a-input--error': errors.has('login.password') }"
            v-model="password"
            v-validate="'required'"
            data-vv-name="password"
            :data-vv-as="$t('login.passwordLC')"
            data-vv-delay="1000"
            data-vv-scope="login"
            data-test="login-password" />
          <v-message
            type="error"
            subtype="basic"
            v-show="errors.has('login.password')"
            data-test="login-password-error">
            <icon slot="icon" name="times" />
            <span slot="text">{{ errors.first('login.password') }}</span>
          </v-message>
        </div>
        <div slot="formButtons">
          <v-button
            type="cta-1"
            href="#"
            subtype="submit"
            class="float-right"
            data-test="login-button">
            <icon name="check"></icon>
            <span>{{ $t('login.login') }}</span>
          </v-button>
        </div>
      </v-form>
      <div class="p-login__forgot-password">
        <!-- <a href="https://app.signable.co.uk/lost" target="_blank" data-test="login-forgot-password">
          {{ $t('login.forgotPassword') }}
        </a> -->
        <a href="#">
          {{ $t('login.register') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { VInput, VButton, VLoadingSpinner, VMessage } from '@signable/ui-kit/src/atoms';
import { VForm } from '@signable/ui-kit/src/organisms';

export default {
  name: 'Login',
  inject: {
    $validator: '$validator',
  },
  components: {
    VInput,
    VButton,
    VLoadingSpinner,
    VMessage,
    VForm,
  },
  data() {
    return {
      email: null,
      password: null,
      loading: false,
    };
  },
  mounted() {
    if (this.$route.query.token && this.$auth.isAuthenticated() !== true) {
      const { token } = this.$route.query;
      this.loading = true;
      this.GET_USER_FROM_TOKEN({ token }).then((response) => {
        if (response.isAuthenticated) {
          console.log('already logged in');
          location.reload(); // eslint-disable-line
        }
      });
    }
  },
  methods: {
    ...mapActions('user', [
      'LOGIN',
    ]),
    validateForm(scope) {
      this.$validator.validateAll(scope).then((validated) => {
        if (validated) {
          this.loading = true;
          console.log('OO');
          this.LOGIN({ email: this.email, password: this.password }).then(() => {
            console.log('A');
            if (this.$auth.isAuthenticated() === true) {
              console.log('B');
              console.log(this.$route.params.routerFrom);
              console.log(this.$router);
              this.$router.push({
                name: 'Dashboard',
              });
              // this.$router.go('/');
              console.log('C');
            }
          }).catch(() => {
            console.log('D');
            this.loading = false;
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils.scss';

  $parent: '.p-login';

  #{$parent} {
    position: absolute;
    height: 100vh !important;
    width: 100vw !important;
    z-index: 10;
    top: 0;
    left: 0;
    margin-top: 0;
    background: $signable-secondary-1;
    overflow: hidden;
    &__form {
      width: 100%;
      max-width: 280px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      padding: $spacing-small;
      box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.15);
      border: none;
      border-radius: 3px;

      &__logo {
        padding: $spacing-small;
        margin-bottom: $spacing-small;
        border-bottom: 1px solid $color-border;
      }

      form {
        div {
          margin-top: 0;
        }

        .a-message {
          margin-top: 0;
          margin-bottom: $spacing-small;
        }
      }
    }

    &__forgot-password {
      text-align: center;
      font-size: $font-size-xs;
      padding-top: $spacing-small;
      margin-top: $spacing-small;
      border-top: 1px solid #dfdfdf;
    }
  }

  // TODO: should be in its own component
  .a-input {
    margin-bottom: $spacing-small;
  }
</style>
